import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "wrapper-delivery" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "files" }
const _hoisted_5 = { class: "info-right" }
const _hoisted_6 = { name: "slide" }
const _hoisted_7 = { class: "secondary-info" }
const _hoisted_8 = { class: "light-text" }
const _hoisted_9 = { class: "light-text center" }
const _hoisted_10 = { class: "light-text center" }
const _hoisted_11 = { class: "info-right" }
const _hoisted_12 = { name: "slide" }
const _hoisted_13 = { class: "secondary-info" }
const _hoisted_14 = { class: "light-text" }
const _hoisted_15 = { class: "light-text center" }
const _hoisted_16 = { class: "light-text center" }
const _hoisted_17 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPreviewFile = _resolveComponent("ModalPreviewFile")!
  const _component_Title = _resolveComponent("Title")!
  const _component_AdminSelect = _resolveComponent("AdminSelect")!
  const _component_AdminInput = _resolveComponent("AdminInput")!
  const _component_AdminTextArea = _resolveComponent("AdminTextArea")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ModalPreviewFile, { style: {"display":"none"} }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Title, { title: "Entregas" }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AdminSelect, {
          options: _ctx.clientList,
          id: 'Clients',
          text: _ctx.client.val,
          "onUpdate:text": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client.val) = $event)),
          value: _ctx.client.val,
          label: 'Cliente',
          "has-error": _ctx.client.enabled,
          error: _ctx.client.errors.length === 0 ? '' : _ctx.client.errors[0],
          class: "client"
        }, null, 8, ["options", "text", "value", "has-error", "error"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_AdminInput, {
            text: _ctx.name.val,
            "onUpdate:text": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name.val) = $event)),
            value: _ctx.name.val,
            label: 'Nombre de la entrega',
            "has-error": _ctx.name.enabled,
            error: _ctx.name.errors.length === 0 ? '' : _ctx.name.errors[0]
          }, null, 8, ["text", "value", "has-error", "error"]),
          _createVNode(_component_AdminTextArea, {
            text: _ctx.message.val,
            "onUpdate:text": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.message.val) = $event)),
            value: _ctx.message.val,
            label: 'Mensaje de la entrega',
            "has-error": _ctx.message.enabled,
            error: _ctx.message.errors.length === 0 ? '' : _ctx.message.errors[0]
          }, null, 8, ["text", "value", "has-error", "error"]),
          _createElementVNode("div", {
            class: "drag-drop",
            onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)))
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("img", {
              src: "assets/administrator/DragAndDrop.svg",
              alt: "Suelta los archivos aquí",
              class: "icon"
            }, null, -1),
            _createElementVNode("p", null, "Suelta los archivos aquí", -1)
          ]), 32)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["wrapper-file approved-files", { 'is-expanded': _ctx.showApproved }])
          }, [
            _createElementVNode("div", {
              class: "first-info",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSection('approved')))
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "yellow-text" }, "Archivos aprobados", -1)),
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "light-text" }, "2", -1)),
                _createElementVNode("img", {
                  src: "assets/administrator/DownArrow.svg",
                  class: _normalizeClass(["arrow-icon", { 'rotate-down': _ctx.showApproved }]),
                  alt: "Toggle"
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("ul", _hoisted_7, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "line-container" }, [
                  _createElementVNode("div", { class: "line" })
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (resource, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "file-item",
                    key: index
                  }, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(resource.name), 1),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(resource.extension), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(resource.size), 1)
                  ]))
                }), 128))
              ], 512), [
                [_vShow, _ctx.showApproved]
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["wrapper-file rejected-files", { 'is-expanded': _ctx.showRejected }])
          }, [
            _createElementVNode("div", {
              class: "first-info",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSection('rejected')))
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "yellow-text" }, "Archivos rechazados", -1)),
              _createElementVNode("div", _hoisted_11, [
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "light-text" }, "4", -1)),
                _createElementVNode("img", {
                  src: "assets/administrator/DownArrow.svg",
                  class: _normalizeClass(["arrow-icon", { 'rotate-down': _ctx.showRejected }]),
                  alt: "Toggle"
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("ul", _hoisted_13, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "line-container" }, [
                  _createElementVNode("div", { class: "line" })
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resources, (resource, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "file-item",
                    key: index
                  }, [
                    _createElementVNode("p", _hoisted_14, _toDisplayString(resource.name), 1),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(resource.extension), 1),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(resource.size), 1)
                  ]))
                }), 128))
              ], 512), [
                [_vShow, _ctx.showRejected]
              ])
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_StandardButton, {
            buttonLabel: 'Cancelar',
            isCancel: true,
            onClick: _ctx.backDeliveriesOption
          }, null, 8, ["onClick"]),
          _createVNode(_component_StandardButton, {
            buttonLabel: 'Guardar',
            "is-disabled": _ctx.successForm,
            onClick: _ctx.createDeliveryTransaction
          }, null, 8, ["is-disabled", "onClick"])
        ])
      ])
    ])
  ], 64))
}